<template>
  <div :class="['panel', { collapsed: menuCollapsed }]">
    <Toast />
    <Loading v-show="isLoading('panel')" />
    <div v-show="!isLoading('panel')">
      <div v-show="showVerticalFilter">
        <VerticalFilter>
          <slot name="content-filter"></slot>
        </VerticalFilter>
      </div>
      <div class="local-container" :class="{ 'layout-small': layout == 'small' }">
        <div v-if="!modal.open && !vodal.open" class="div-message-panel">
          <Messages />
        </div>
        <br>
        <br>
        <div class="row">
          <div class="col-10">
            <div class="div-title">
              <span class="module">
                <span class="icon-panel"><i class="fas fa-compass"></i></span>
                {{ module }} <span v-if="title">|</span></span>
              <span class="title"> {{ title }}</span>
            </div>
          </div>
          <div class="col-2" v-if="currentRoute != 'dashboard'">
            <div class="div-back text-right" @click="back()">
              <i class="fa-solid fa-circle-arrow-left"></i>
              <span> Voltar</span>
            </div>
          </div>
        </div>
        <br v-show="showButtons" />
        <div class="row" v-show="showButtons">
          <div class="col-12" v-show="showButtons">
            <slot name="content-buttons"></slot>
          </div>
        </div>
        <br v-show="showButtons || showSearch" />
        <div v-show="showButtons || showSearch">
          <div>
            <div v-show="showSearch">
              <Search :extraActive="searchExtraActive" :onRemoveExtraFilter="onSearchRemoveExtraFilter" />
            </div>
          </div>
        </div>
        <br v-show="showSearch" />
        <div>
          <slot name="content-main"></slot>
        </div>
      </div>
    </div>
    <br /><br /><br />
  </div>
</template>

<script>
import Toast from "../shared/Toast.vue";
import Messages from "../shared/Messages.vue";
import Search from "../shared/Search.vue";
import Loading from "../shared/Loading.vue";
import VerticalFilter from "../shared/VerticalFilter.vue";
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded";

import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  name: "Panel",
  components: {
    Loading,
    VerticalFilter,
    Search,
    Messages,
    Toast,
    Molded,
  },
  props: {
    module: String,
    title: String,
    showVerticalFilter: Boolean,
    showSearch: Boolean,
    showButtons: Boolean,
    layout: {
      type: String,
      default: "small"
    },
    searchExtraActive: {
      type: Boolean,
      default: false,
    },
    onSearchRemoveExtraFilter: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      currentRoute: this.$route.name,
    };
  },
  created() {
    this.addLoading("panel");
  },
  updated() {
    this.currentRoute = this.$route.name;
  },
  computed: {
    ...mapGetters("generic", ["isLoading", "event"]),
    ...mapState("generic", ["modal", "vodal", "menuCollapsed"]),
  },
  methods: {
    ...mapMutations("generic", ["addLoading"]),
    back() {
      window.history.back();
    },
  },
};
</script>
<style scoped>
.local-container {
  margin: auto;
  padding-left: 100px;
}

.div-title {
  margin-top: 15px;
}

.module {
  font-size: 17px;
  font-weight: 400;
  color: #aaaebb;
}

.title {
  font-size: 20px;
  font-weight: 500;
}

.icon-panel {
  opacity: 0.8;
  font-size: 20px;
}

.c-back {
  margin-top: 20px;
  margin-right: 12px;
  font-size: 16px;
  cursor: pointer;
  color: #8ca1b7;
}

.c-back:hover {
  color: #8ca1b7;
}

.panel {
  padding-right: 30px;
  margin-left: 130px;
}

.panel.collapsed {
  margin-left: 10px;
  transition: all 0.3s ease;
}

.div-back {
  margin-top: 18px;
  font-size: 16px;
  cursor: pointer;
  padding-top: 3px;
  padding-left: 10px;
  padding-right: 30px;
  font-weight: 400;
  color: #242424;
}

.div-back:hover {
  color: #505050;
}

.div-message-panel {
  width: calc(100% - 60px);
  position: fixed;
  top: -55px;
  left: 30px;
  right: 30px;
  margin: 0;
  z-index: 2000 !important;
  transition: top 0.5s ease;
}

@media (max-width: 768px) {
  .panel {
    padding-right: 12px;
  }

  .panel.collapsed {
    margin-left: 10px;
  }

  .local-container {
    padding-left: 85px;
  }

  .div-message-panel {
    width: calc(100% - 24px);
    left: 12px;
    right: 12px;
  }
}

</style>
